import { useEffect, useCallback } from 'react'
import styled from 'astroturf/react'
import moment from 'moment-timezone'
const primaryColor = 'var(--primary-color, rgb(0, 105, 255))'
const textColorSecondary4 = 'var(--text-color-secondary-4, rgba(255, 255, 255, 1))'
import { useDispatch, useSelector } from 'react-redux'
import { useDeviceType } from '@calendly/ui/hooks/use-device-type'
import { formatTime } from '@calendly/booking-kit/services/time_format'

import { selectCalendarDay } from 'actions/calendar_day'
import { timezoneSelector, timeNotationSelector } from 'selectors'
import { selectedSpotsSelector } from 'selectors/calendar'
import { syncSpotUrlParameters } from 'actions/navigation'
import { addOrRemoveSpot } from 'actions/spot'
import { calendarSpotsWithConflictsSelector } from 'selectors/mutual_availability'

import { TimeButton } from '../time_button'
import { TimeButtonWrapper } from '../styles'
import { useDetectConflicts } from '../../mutual_availability/use_detect_conflicts'

import InviteeCountTimeButton from './invitee_count_time_button'
import { MobileInviteeCountTimeButton } from './invitee_count_time_button/mobile_invitee_count_time_button'
import _Container from "spot_list-Container.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/select_date_time/flat_spotpicker/spot_list.js?styleId=Container";
import _StyledTimeButton from "spot_list-StyledTimeButton.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/select_date_time/flat_spotpicker/spot_list.js?styleId=StyledTimeButton";


const Container = /*#__PURE__*/styled('div', null, {
  displayName: "Container",
  styles: _Container
})

const StyledTimeButton = /*#__PURE__*/styled(TimeButton, null, {
  displayName: "StyledTimeButton",
  styles: _StyledTimeButton,
  attrs: props => ({
    ...props,
    isPhone: useDeviceType('isPhone')
  })
})

const SpotList = ({ day }) => {
  const spots = day.spots
  const hasInvitees = spots.some((spot) => spot.invitees)
  const dispatch = useDispatch()
  const selectedSpots = useSelector(selectedSpotsSelector)
  const spotsWithConflicts = useSelector(calendarSpotsWithConflictsSelector)
  const timezone = useSelector(timezoneSelector)
  const timeNotation = useSelector(timeNotationSelector)
  const [detectConflictsEnter, detectConflictsLeave] = useDetectConflicts()
  const isPhone = useDeviceType('isPhone')
  const VotesButton = isPhone ? MobileInviteeCountTimeButton : InviteeCountTimeButton

  const selectDay = useCallback(() => {
    const dayObj = {
      id: day.date,
      date: moment(day.date)
    }
    dispatch(selectCalendarDay(dayObj, false))
  }, [day.date, dispatch])

  const onSpotSelect = (spot) => {
    dispatch(addOrRemoveSpot(spot))
    dispatch(syncSpotUrlParameters())
  }

  const onMouseEnter = (spot) => {
    selectDay()
    detectConflictsEnter(spot)
  }

  useEffect(() => {
    if (isPhone) selectDay()
  }, [isPhone, selectDay])

  const EnabledTimeButton = hasInvitees ? VotesButton : StyledTimeButton

  return (
    <Container data-component="flat-spot-list">
      {spots.map((spot) => {
        const hasConflicts = spotsWithConflicts.has(spot.start_time)
        const parsedTime = moment.tz(spot.start_time, timezone)
        const time = formatTime(parsedTime, timeNotation)
        const isSelected = selectedSpots.map((selectedSpot) => selectedSpot.start_time).includes(spot.start_time)

        return (
          <EnabledTimeButton
            onMouseEnter={() => onMouseEnter(spot)}
            onMouseLeave={() => detectConflictsLeave(spot)}
            timeFormat12h="h:mm A"
            key={spot.start_time}
            spot={spot}
            isSelected={isSelected}
            data-start-time={time}
            onClick={() => onSpotSelect(spot)}
            hasFreeMarker={!hasConflicts}
          />
        )
      })}
    </Container>
  )
}
export default SpotList
